import React from 'react';

const TrustedBy = () => {
  // Die Liste wurde geleert, damit keine Namen mehr angezeigt werden
  const companies = [];

  return (
    <div className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <p className="text-center text-gray-500 uppercase tracking-wide text-sm font-semibold mb-8">
          ✨ Vertraut von über 80+ Schweizer Handwerksbetrieben
        </p>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {companies.map((company, idx) => (
            <div key={idx} className="p-4 text-center">
              {/* Dieser Teil bleibt leer, da keine Firmen in der Liste sind */}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustedBy;
